import React, {useEffect, useState} from 'react';
import ThemeService from "../../services/ThemeService";
import {message, Spin} from "antd";
import SubDealerService from "../../services/SubdealerService";
import {showErrors} from "../../services/utils";


function ThemeBootstrap({ children }) {

  const [loading, setLoading] = useState(true);

  // console.log('11111111111')

  useEffect(() => {

    let cancelled = false;

    const cachedConfig = ThemeService.getConfiguration();

    // console.log('ThemeService.getConfiguration():', cachedConfig)

    if (cachedConfig) {
      ThemeService.applyTheme(cachedConfig);
      setLoading(false);
      return;
    }

    SubDealerService.getSubDealerProfile()
      .then((response) => {

        if (cancelled) {
          return;
        }
        // console.log('SubDealerService.getSubDealerProfile():', response)

        ThemeService.applyTheme(response);
        ThemeService.saveConfiguration(response);

      })
      .catch((error) => {
        console.log('error:', error);

        const {errorMsg} = showErrors(error);
        message.error(errorMsg);
      })
      .finally(() => {
        setLoading(false);
      });

    return () => {
      cancelled = true
    }
  }, [])

  if (loading) {
    return (
      <div
        style={{
          height: '100vh',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }}
      >
        <Spin
          size="large"
        />
      </div>
    );
  }

  return children;
}


export default ThemeBootstrap